module.exports = __webpack_public_path__ + "static/media/Band.afd92a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Band.png
// module id = 133
// module chunks = 0